import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { SERVICES_TO_REGIONS } from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import MatchTimeline from "@/game-lol/models/lol-match-timeline.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getTimeline({ region, matchId }) {
  if (!region || !SERVICES_TO_REGIONS[region.toLowerCase()]) return null;
  if (!matchId) return null;

  return queryGQL(appURLs.RIOT, GraphQLTemplates.LeagueTimeline, {
    region: region.toUpperCase(),
    matchId,
  });
}

export default function ({
  region,
  matchId,
  options = {},
}: {
  region: string;
  matchId: string | number;
  options?: object;
}) {
  return getData(
    getTimeline({ region, matchId }),
    MatchTimeline,
    ["lol", "matchTimeline", matchId],
    {
      shouldFetchIfPathExists: false,
      ...options,
    },
  );
}
